export function BranchContactsCtrl ($scope, $uibModal, $state, matches, messages, BranchContacts) {
  $scope.areAllMatchesLinked = false;
  $scope.branchContacts      = new BranchContacts();
  $scope.matches             = matches;
  $scope.matchWith           = 'customers';

  $scope.isMatchedWith = function (type) {
    return $scope.matchWith === type;
  }

  $scope.toggleMatches = function () {
    switch ($scope.matchWith) {
      case 'vendors':
        $scope.matchWith = 'customers';
        break;
      case 'customers':
      default:
        $scope.matchWith = 'vendors';
        break;
    }

    $scope.branchContacts.getMatches($scope.matchWith).then(function (matches) {
      $scope.matches = matches;
    });
  }

  $scope.openMoreMatches = function (match) {
    $scope.branchContacts.viewMoreMatches($scope.matchWith, match).then(function (contact) {
      match.branch_contact = contact;
    });
  }

  $scope.toggleAllLinked = function () {
    var link = !$scope.areAllMatchesLinked;

    $scope.matches.forEach(function (match) {
      match.linked = link;
    });

    $scope.areAllMatchesLinked = link;
  }

  $scope.saveMatches = function () {
    var linkedMatches = $scope.matches.filter(function (match) {
      return match.linked;
    }).map(function (match) {
      return {
        accounting_id: match.branch_contact.accounting_id,
        id: match.contact.id
      };
    });

    $scope.branchContacts.saveMatches($scope.matchWith, linkedMatches).then(function () {
      messages.show('Save Successful', 'success');

      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  }

  $scope.setLinkedFlag = function (match) {
    $scope.areAllMatchesLinked = match.linked;
  }
}
